import React from 'react';
import {MasterLayout} from 'components/layouts';
import {
  HomeBanner,
  HighlightBusinessesContainer,
  FavoriteCategoryContainer,
  HighlightProductByCategoryContainer,
  HighlightPromotionContainer,
  TradeNewsContainer,
  EasyNeedOfferContainer,
  NeedOffersByCategoryContainer,
  SupportInfoContainer,
  NewsLetterRegister,
  HotProducts,
  ProductsByCategory,
  HighlightPromotions
} from './sub-view';

import {withRouter} from 'react-router';
import title from 'constants/TitlePages.js';

import { asyncConnect } from 'redux-connect';
import CONFIG from 'base/constants/config';

@asyncConnect([{
  key: 'nokey',
  promise: ({ match: { params }, store: { dispatch }, helpers }) => {
    dispatch({
      type: 'SEO_INFO',
      data: {
        title: title.Home,
        description: 'Sàn giao dịch thương mại điện tử thành phố Huế – HueTrade là một thị trường trực tuyến, một địa điểm họp chợ online được thực hiện trên mạng internet giữa người bán và người mua, ở đó những người tham gia có thể tự mình tìm kiếm thông tin về thị trường và sản phẩm – dịch vụ, thiết lập mối quan hệ cũng như tiến hành đàm phán trong từng giao dịch.',
        image: `${CONFIG.UploadImageURL}/03708aed6ad48b41b843785cf1d0d3de.jpg`
      }
    });
  }
}])
class Home extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Home;
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 150);
  }

  render() {
    return (
      <MasterLayout>
        <HomeBanner/>
        <HighlightProductByCategoryContainer/>
        <HighlightPromotionContainer/>
        <FavoriteCategoryContainer/>
        <HotProducts/>
        <TradeNewsContainer/>
        <NewsLetterRegister/>
      </MasterLayout>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./components/home/Home.jsx